<template>
  <div>
    <el-dialog class="dialogImgAddTag"
               title="选择图片对应标签"
               size="tiny"
               :visible.sync="dialogImageAddTagVisible">
      <el-col class="radioGroup" style="margin-bottom: 30px;">
        <el-col :span="6" style="height: 30px;line-height: 30px;text-align: center;margin: 5px 0;" v-for="(tag,index) in tagList" :key="index">
          <el-radio class="is-bordered" :class="tag.isChecked == true ? 'is-checked' : ''" v-model="tagTypeSelected" :label="tag.tagType" @click.native="tagTypeChange(tag)" border>{{tag.tagName}}</el-radio>
        </el-col>
      </el-col>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogImageAddTagVisible = false" style="margin-right: 2px">取消</el-button>
        <el-button type="primary" @click="imageAddTag" >保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import bus from '../../assets/js/bus'
  import utils from '../../assets/js/utils'
  import http from '../../assets/js/http'

  export default({
    props : [],
    data(){
      return{
        dialogImageAddTagVisible:false,
        imageId:undefined,
        imageType:undefined,
        tagList:[
          {tagType:"B",tagName:"卧室"},
          {tagType:"C",tagName:"客厅"},
          {tagType:"D",tagName:"餐厅"},
          {tagType:"E",tagName:"外景"},
          {tagType:"K",tagName:"厨房"},
          {tagType:"V",tagName:"阳台"},
          {tagType:"W",tagName:"卫生间"},
          {tagType:"O",tagName:"其他"},
        ],
        tagTypeSelected:"O",
        tagTypeChecked:{
          tagType:"O",tagName:"其他"
        },
      }
    },
    mounted(){
      this.$nextTick(function(){
        var that = this;
        bus.$on('showImageAddTag', function (data) {
          that.dialogImageAddTagVisible = true;
          that.tagTypeSelected = data.imageTag;
          that.imageId = data.imageId;
          that.imageType = data.imageType;
          for(var obj of that.tagList){
            if(obj.tagType == that.tagTypeSelected) {
              obj.isChecked = true;
            } else {
              obj.isChecked = false;
            }
          }
        });
      })
    },
    methods:{
      imageAddTag: function() {
        var params = {
          imageId: this.imageId,
          imageType: this.imageType,
          imageTag: this.tagTypeSelected
        };
        var that = this;
        http.imageAddTag(that, params, function (response) {
          bus.$emit('imageAddTagSuccess' + that.imageType,{
            imageId: that.imageId,
            imageType: that.imageType,
            imageTagName: that.tagTypeChecked.tagName,
            imageTag: that.tagTypeChecked.tagType
          });
          that.dialogImageAddTagVisible = false;
          that.$message.success("图片标签设置成功");
        });
      },
      tagTypeChange: function(tag) {
        this.tagTypeChecked = tag;
        for(var obj of this.tagList){
          obj.isChecked = false;
        }
        tag.isChecked = true;
      }
    }
  })
</script>

<style lang="scss">
  .dialogImgAddTag{
  .el-radio{
    margin-right: 10px;
  }
  .el-radio__input{
    vertical-align: baseline
  }
  .el-radio{
    color: #333;
    padding: 0 5px;
    height: 100%;
    width: 50%;
  }
  .el-radio.is-bordered{
    line-height: 26px;
    border: 1px solid #e1e6f1;
    border-radius: 3px;
  }
  .el-radio.is-bordered.is-checked{
    border: 1px solid #6cc1fb;
    background: #ecf9fd;
    color: #20a0fc;
  }

  .el-radio__label{
    padding-left: 0;
  }
  .el-radio__inner{
    display: none;
    width: 10px;
    height: 10px;
  }
  .el-radio__inner::after{
    width: 0;
  }
  .el-radio__input.is-checked .el-radio__inner{
    display: none;
  }
  .el-radio.is-bordered+.el-radio.is-bordered{
    margin-left: 30px;
  }
    .el-dialog{
      width: 450px;
    }
  }
</style>



// WEBPACK FOOTER //
// dialogImageAddTag.vue?65d6935a